function OrderDetail({ order, updateplat, selectedDay, selectedHour }) {
  return (
    <div className="detail-card">
      <h3>
        {order?.folio} - {order?.user_name}
      </h3>

      <table className="detail-table">
        <thead>
          <tr>
            <th style={{ width: "20%" }}>Productos</th>
            <th style={{ width: "10%" }}>Cantidad</th>
            <th style={{ width: "15%" }}>Ingredientes</th>
            <th style={{ width: "15%" }}>Extras</th>
            <th style={{ width: "30%" }}>Notas</th>
            <th style={{ width: "10%" }}>Estatus</th>
          </tr>
        </thead>

        <tbody>
          {order?.detalle
            ?.filter((ite) => {
              if (
                ite.selectedDate === selectedDay &&
                (ite.selectedTime === selectedHour ||
                  selectedHour === "cantidad")
              ) {
                return true;
              }
              let fech = new Date(order.fecha.seconds * 1000);
              let dateord = fech.toISOString().split("T")[0];
              let hora = fech.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false, // Set to true for AM/PM
              });
              if (
                !ite.selectedDate &&
                dateord === selectedDay &&
                (hora === selectedHour || selectedHour === "cantidad")
              ) {
                return true;
              }
              return false;
            })
            .map((item, index) => {
              let texto = "PREPARAR";
              if (item.status !== "ATENDIDO" && item.status !== "PENDIENTE") {
                texto = item.status;
              }
              if (item.status === "ENTREGAR") {
                texto = "LISTO";
              }
              return (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.cantidad}</td>
                  <td>
                    {Object.keys(item.ingredientes).map((element) => {
                      return (
                        <>
                          <strong>
                            {"-" +
                              item.ingredientes[element].name +
                              "(" +
                              item.ingredientes[element].cantidad +
                              ")" +
                              "\n "}
                          </strong>
                          <br />
                        </>
                      );
                    })}{" "}
                  </td>
                  <td>
                    {Object.keys(item.anadidos).map((element) => {
                      return (
                        <>
                          <strong>
                            {"-" +
                              item.anadidos[element].name +
                              "(" +
                              item.anadidos[element].cantidad +
                              ")" +
                              "\n "}
                          </strong>
                          <br />
                        </>
                      );
                    })}{" "}
                  </td>
                  <td>{item.note}</td>
                  <td>
                    <button
                      className={texto}
                      onClick={(e) => {
                        e.preventDefault();
                        updateplat(item);
                      }}
                    >
                      {texto}
                    </button>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

      {/* <div className="notes">
        <strong>Notas generales:</strong> Sin picante
      </div> */}
    </div>
  );
}

export default OrderDetail;
